export const calendarSettingsKeys = {
    all: ['calendar-settings'],
    settings: () => [...calendarSettingsKeys.all, 'settings']
};
